{
  "title": "Автопилот",
  "lead": "Агент на сервере присылает метрики, состояние сервисов и контейнеров и предупреждает о проблемах. Он только смотрит и предупреждает: ничего на сервере не меняет.",
  "free": "Бесплатно",
  "agentOffline": "Агент не на связи — сервер выключен или агент остановлен; отчёты недоступны.",
  "unavailable": {
    "title": "Автопилот недоступен",
    "text": "В этой установке CloudServer Автопилот не настроен."
  },
  "what": {
    "metrics": "Метрики: процессор, память, swap, нагрузка, диски, сеть, температура — за час, сутки, неделю и месяц.",
    "services": "Сервисы systemd и контейнеры Docker: состояние, перезапуски, ресурсы.",
    "warnings": "Предупреждения: обновления пакетов, сертификаты, заполненные диски, упавшие сервисы.",
    "safety": "Агент работает от пользователя beszel, не открывает портов и не трогает файрвол. Он ничего не обновляет и не перезапускает: команды для исправления вы выполняете сами."
  },
  "off": {
    "title": "Автопилот выключен",
    "enable": "Включить Автопилот",
    "guest": "Включить Автопилот может владелец проекта или администратор."
  },
  "docker": {
    "label": "Следить за контейнерами Docker",
    "hint": "Агента добавят в группу docker. Это права уровня root: через Docker можно управлять всем сервером. Агент только читает список и статистику контейнеров."
  },
  "status": {
    "waiting": "Ждём агента",
    "connected": "Агент подключился",
    "reporting": "Работает",
    "stale": "Нет отчётов",
    "expired": "Ключ установки истёк"
  },
  "statusHint": {
    "waiting": "Агент ещё не подключился. Новый сервер установит его сам при первом запуске; на работающем выполните команду установки. Ключ действует до {{time}}.",
    "connected": "Агент подключился, первый отчёт придёт в течение минуты.",
    "stale": "Последний отчёт — {{time}}. Сервер выключен, агент остановлен или нет связи.",
    "staleNever": "Агент не присылал отчётов. Сервер выключен, агент остановлен или нет связи.",
    "expired": "Агент так и не подключился, а ключ установки истёк. Получите новую команду."
  },
  "health": {
    "ok": "Всё в порядке",
    "warn": "Есть предупреждения",
    "critical": "Требует внимания",
    "unknown": "Нет данных"
  },
  "header": {
    "label": "Состояние сервера",
    "version": "Агент {{version}}",
    "lastSeen": "Отчёт {{time}}",
    "uptime": "Работает {{time}}",
    "cpu": "{{model}} · ядер: {{cores}}",
    "memory": "Память {{size}}"
  },
  "actions": {
    "command": "Команда установки",
    "disable": "Отключить Автопилот"
  },
  "enable": {
    "title": "Включить Автопилот",
    "lead": "CloudServer выдаст команду с одноразовым ключом. Выполните её на сервере от root — агент установится и подключится.",
    "reinstall": "Новая команда заменит прежнюю: прежняя перестанет работать. Это нужно после переустановки сервера.",
    "submit": "Получить команду",
    "commandTitle": "Команда установки",
    "commandLead": "Выполните её на сервере от root. Команда сработает один раз, до {{time}}.",
    "commandLabel": "Команда установки агента",
    "typeInConsole": "Ввести в консоли",
    "consoleHint": "Откроется консоль сервера с этой командой; войдите в систему, затем подтвердите ввод.",
    "consoleOff": "Консоль работает, когда сервер включён.",
    "done": "Готово"
  },
  "disable": {
    "title": "Отключить Автопилот",
    "history": "История метрик этого сервера удалится.",
    "agent": "Агент на сервере останется и будет пытаться подключиться, пока вы не удалите его командой, которую мы покажем.",
    "submit": "Отключить",
    "doneTitle": "Автопилот отключён",
    "doneLead": "Агент на сервере остался. Удалите его этой командой от root:",
    "commandLabel": "Команда удаления агента"
  },
  "copy": "Скопировать",
  "copied": "Скопировано",
  "warnings": {
    "title": "Предупреждения",
    "none": "Предупреждений нет.",
    "fix": "Проверить или исправить (выполните сами):",
    "kinds": {
      "not_reporting": "Агент не присылает отчёты",
      "memory_high": "Память почти заполнена: {{subject}}",
      "disk_full": "Диск почти заполнен: {{subject}}",
      "service_failed": "Сервис упал: {{subject}}",
      "container_unhealthy": "Контейнер нездоров: {{subject}}",
      "container_stopped": "Контейнер остановился с ошибкой: {{subject}}",
      "container_restarting": "Контейнер перезапускается по кругу: {{subject}}",
      "updates_security": "Обновления безопасности: {{subject}}",
      "updates_pending": "Доступны обновления пакетов: {{subject}}",
      "certificate_expiring": "Сертификат скоро истекает: {{subject}}",
      "certificate_expired": "Сертификат истёк: {{subject}}"
    },
    "severity": {
      "warn": "Внимание",
      "critical": "Важно"
    }
  },
  "charts": {
    "title": "Графики",
    "range": "Период",
    "ranges": {
      "1h": "1 час",
      "24h": "24 часа",
      "7d": "7 дней",
      "30d": "30 дней"
    },
    "cpu": "Процессор",
    "memory": "Память",
    "swap": "Swap",
    "load": "Нагрузка (load average)",
    "diskUsage": "Заполнение дисков",
    "diskIo": "Диск: чтение и запись",
    "network": "Сеть",
    "temperatures": "Температура",
    "empty": "За этот период данных пока нет.",
    "celsius": "{{value}}\u00a0°C",
    "series": {
      "cpu": "Загрузка",
      "memory": "Занято",
      "swap": "Занято",
      "load1": "1\u00a0мин",
      "load5": "5\u00a0мин",
      "load15": "15\u00a0мин",
      "read": "Чтение",
      "write": "Запись",
      "in": "Входящий",
      "out": "Исходящий"
    }
  },
  "containers": {
    "title": "Контейнеры Docker",
    "off": "Слежение за контейнерами выключено. Его можно включить новой командой установки.",
    "empty": "Контейнеров нет.",
    "name": "Контейнер",
    "image": "Образ",
    "state": "Состояние",
    "health": "Проверка",
    "cpu": "CPU",
    "memory": "Память",
    "restarts": "Перезапуски",
    "states": {
      "running": "Работает",
      "restarting": "Перезапускается",
      "paused": "Приостановлен",
      "created": "Создан",
      "exited": "Остановлен",
      "dead": "Сломан",
      "unknown": "Неизвестно"
    },
    "healths": {
      "healthy": "Здоров",
      "unhealthy": "Нездоров",
      "starting": "Запускается",
      "none": "Нет проверки"
    }
  },
  "services": {
    "title": "Сервисы systemd",
    "empty": "Агент не прислал список сервисов.",
    "name": "Сервис",
    "state": "Состояние",
    "cpu": "CPU",
    "memory": "Память",
    "restarts": "Перезапуски",
    "states": {
      "active": "Работает",
      "inactive": "Не запущен",
      "failed": "Упал",
      "activating": "Запускается",
      "deactivating": "Останавливается",
      "reloading": "Перечитывает настройки",
      "unknown": "Неизвестно"
    }
  },
  "updates": {
    "title": "Обновления пакетов",
    "unknown": "Агент ещё не проверял обновления.",
    "none": "Все пакеты обновлены.",
    "summary": "Доступно обновлений: {{total}}, из них безопасности: {{security}}.",
    "checked": "Проверено {{time}}.",
    "apply": "Чтобы установить, выполните на сервере от root. CloudServer сам ничего не обновляет.",
    "commandLabel": "Команда обновления пакетов",
    "package": "Пакет",
    "current": "Установлен",
    "available": "Доступен",
    "security": "Безопасность"
  },
  "certificates": {
    "title": "Сертификаты TLS",
    "none": "Агент не прислал сертификатов для проверки.",
    "host": "Адрес",
    "expires": "Истекает",
    "left": "{{time}}"
  },
  "ssh": {
    "title": "Входы по SSH",
    "unavailable": "Агент этой версии не собирает входы по SSH. Они появятся вместе с проверками безопасности.",
    "empty": "Входов не было.",
    "note": "Видно всем, у кого есть доступ к проекту. Хранится 90 дней.",
    "at": "Когда",
    "user": "Пользователь",
    "ip": "Адрес",
    "method": "Способ",
    "result": "Итог",
    "success": "Вход",
    "failed": "Отказ"
  },
  "unit": {
    "percent": "{{value}}\u00a0%"
  },
  "role": {
    "title": "Роль агента",
    "lead": "Что можно делать на этом сервере кроме мониторинга. Основа — диагностика (только чтение); поверх неё две независимые возможности: действия Автопилота и управление приложениями, в любом сочетании. Свободной оболочки нет ни у кого: выполняются только команды из каталога CloudServer и подписанные нами пакеты.",
    "names": {
      "monitoring": "Только мониторинг",
      "agent-ro": "Диагностика, только чтение",
      "agent-rw": "Диагностика и действия Автопилота",
      "agent-apps": "Диагностика и управление приложениями",
      "agent-manage": "Диагностика, действия и приложения"
    },
    "short": {
      "monitoring": "мониторинг",
      "agent-ro": "диагностика, чтение",
      "agent-rw": "диагностика и действия",
      "agent-apps": "диагностика и приложения",
      "agent-manage": "действия и приложения"
    },
    "hints": {
      "monitoring": "Только агент Автопилота: метрики, службы, контейнеры и предупреждения. По запросу на сервере ничего не выполняется.",
      "agent-ro": "Добавляет пользователя cloudserver-agent (без оболочки и sudo; может читать журнал и логи) и помощника, который выполняет диагностические команды только для чтения из нашего каталога: диски, память, процессы, порты, состояние служб, журнал службы или контейнера, разрешённые файлы конфигурации. Секреты скрываются из вывода.",
      "agent-rw": "Диагностика и действия Автопилота: перезапуск служб и контейнеров, обновления безопасности, порты файрвола, nginx, логи — от root, только из каталога и только после вашего подтверждения. Приложения не ставятся.",
      "agent-apps": "Диагностика и управление приложениями: помощник применяет только пакеты, подписанные нашим ключом, пишет только свои файлы с префиксом cs- (файлы клиента меняет только по карточке), и останавливается, если их меняли вручную. Действий Автопилота из каталога нет.",
      "agent-manage": "Диагностика, действия Автопилота и управление приложениями: всё, что дают обе возможности. Так же работали серверы с прежней ролью «Управление пакетами»."
    },
    "root": "Команды от root, но только из каталога CloudServer или из подписанных нами пакетов. Включайте для серверов, где Автопилот должен исправлять проблемы или ставить приложения после вашего подтверждения.",
    "change": "Изменить роль",
    "check": "Проверить роль",
    "helper": "На сервере: помощник {{version}}, роль «{{role}}», команд: {{count}} · проверено {{time}}",
    "helperNever": "Ещё не проверялось. Когда команда роли выполнится на сервере, нажмите «Проверить роль».",
    "mismatch": "На сервере роль «{{server}}», в панели — «{{panel}}». Выполните команду роли на сервере.",
    "try": "Команда для проверки",
    "commands": {
      "agent_info": "Сведения о помощнике",
      "uptime": "Время работы и нагрузка",
      "df": "Место на дисках",
      "free": "Память",
      "systemctl_failed": "Упавшие службы",
      "os_release": "Версия системы"
    },
    "result": {
      "label": "Вывод {{command}}",
      "exit": "Код выхода {{code}}",
      "noExit": "Без кода выхода",
      "duration": "{{ms}}\u00a0мс",
      "truncated": "Вывод обрезан на 64\u00a0КБ.",
      "redacted": "Скрыто секретов в выводе: {{count}}."
    },
    "dialog": {
      "title": "Роль агента",
      "lead": "CloudServer сразу сохранит выбор и даст команду, которая приведёт сервер в соответствие. Выполните её на сервере от root.",
      "submit": "Сохранить и получить команду",
      "installTitle": "Команда для роли",
      "installLead": "Выполните её на сервере от root. Она ставит помощника и пользователя cloudserver-agent, доверяет SSH-сертификатам организации только для этого пользователя, а для изменений добавляет правило sudoers (проверяется visudo и при ошибке снова удаляется).",
      "removeTitle": "Команда, удаляющая части роли",
      "removeLead": "Выполните её на сервере от root. Панель перестаёт пользоваться прежней ролью сразу.",
      "noneLead": "На сервере ничего делать не нужно: там уже только мониторинг.",
      "commandLabel": "Команда роли"
    },
    "capabilityHints": {
      "actions": "Добавляет правило sudoers, по которому cloudserver-agent может выполнять от root только команды изменения помощника: перезапустить, перечитать, запустить или остановить службу или контейнер, поставить обновления безопасности или пакет из репозитория дистрибутива, открыть или закрыть порт в файрволе, проверить и перечитать nginx, повернуть логи. Каждая выполняется только после вашего подтверждения кнопкой. Файлы, пользователи, настройки SSH и ключи не меняются.",
      "apps": "Добавляет установку приложений CloudServer: помощник применяет только пакеты, подписанные нашим ключом (проверяет подпись сам), пишет только свои файлы с префиксом cs- и останавливается, если их меняли вручную; файлы клиента (например, /etc/docker/daemon.json) меняет только по карточке с точной правкой. Каждое изменение — ревизия с откатом, всё попадает в журнал изменений."
    },
    "levels": {
      "monitoring": "Только мониторинг",
      "read": "Диагностика (чтение)"
    },
    "capabilities": {
      "legend": "Поверх диагностики",
      "hint": "Каждая возможность включается отдельно, в любом сочетании.",
      "needsRead": "Сначала выберите «Диагностика (чтение)».",
      "actions": "Действия Автопилота",
      "apps": "Управление приложениями"
    }
  }
}
